import { Logo } from '@/components/brand/Logo'
import { usePrefersReducedMotion } from '@/hooks/usePrefersReducedMotion'
import { cn } from '@/lib/utils'

/**
 * A whole page still loading: the spinning Cai mark from the Get estimates loader, with the
 * label under it. A full load hides it under index.html's splash, which spins and pulses the same way.
 */
export function PageSpinner({
  label,
  contained = false,
}: {
  label?: string
  /** Fills its nearest positioned ancestor instead of the screen, and doesn't hold the boot splash. */
  contained?: boolean
}) {
  const reduceMotion = usePrefersReducedMotion()

  return (
    <div
      data-page-loading={contained ? undefined : ''}
      role="status"
      className={cn(contained ? 'absolute' : 'fixed', 'inset-0')}
    >
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
        {/* Spin and pulse on wrapper divs: an svg's own animation stalls whenever the main thread is busy. */}
        <div className={cn(!reduceMotion && 'animate-[spin_1.2s_linear_infinite]')}>
          <div className={cn(!reduceMotion && 'animate-mark-pulse')}>
            <Logo symbolOnly width={56} aria-label="" className="[&_path]:fill-ink-300" />
          </div>
        </div>
      </div>
      {label ? (
        <h3 className="text-foreground absolute inset-x-0 top-[calc(50%+40px)] text-center text-lg font-semibold">
          {label}
        </h3>
      ) : (
        <span className="sr-only">Loading</span>
      )}
    </div>
  )
}
